import { ResultPagDTO } from '@/interfaces/base-dto';
import {
  FiltroGrupoEnteralParmDTO,
  FiltroProdutoEnteralParmDTO, GrupoEnteralDetalheDTO,
  GrupoEnteralListItemDTO,
  GrupoEnteralParmDTO,
  ProdutoEnteralDetalheDTO, ProdutoEnteralListItemDTO
} from '@/interfaces/enteral';
import { ENDPOINTS } from '@/settings/api-settings';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from './api';

export function getEnteralsGroups(
  filtros: FiltroGrupoEnteralParmDTO,
): Observable<ResultPagDTO<GrupoEnteralListItemDTO>> {
  return from(apiClient.get(ENDPOINTS.ENTERAL_GROUP, filtros)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function getEnteralGroup(id: Number): Observable<GrupoEnteralDetalheDTO> {
  return from(apiClient.get(`${ENDPOINTS.ENTERAL_GROUP}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function saveEnteralGroup(grupo: GrupoEnteralParmDTO): Observable<Number> {
  if (grupo.id != null) {
    return updateEnteralGroup(grupo);
  }
  return from(apiClient.post(ENDPOINTS.ENTERAL_GROUP, grupo)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function updateEnteralGroup(grupo: GrupoEnteralParmDTO): Observable<Number> {
  return from(apiClient.put(ENDPOINTS.ENTERAL_GROUP, grupo)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function getEnteralsProducts(
  filtros: FiltroProdutoEnteralParmDTO,
): Observable<ResultPagDTO<ProdutoEnteralListItemDTO>> {
  return from(apiClient.get(ENDPOINTS.ENTERAL_PRODUCT, filtros)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function getEnteralProduct(id: Number): Observable<ProdutoEnteralDetalheDTO> {
  return from(apiClient.get(`${ENDPOINTS.ENTERAL_PRODUCT}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}
